module.exports = __webpack_public_path__ + "static/img/7.4c71f085.jpg";